import React from "react";
import { ORDINALS, WEEKDAYS } from "./options";

/* Was an uncontrolled stack of antd Row/Col whose Selects were handed a
   `getSelectedOptions` prop antd does not have, so the second row never
   reported anything. Now a controlled panel of the Custom modal.
   Previous version in git history. */

/**
 * Month panel of the Custom recurrence modal.
 *
 *   value: { type: "day" | "the", day, interval, ordinal, weekday, theInterval }
 *
 * Styles come from CustomRecurrenceModal.css, which the modal imports.
 */
export default function MonthlyForm({ value, onChange }) {
  const set = (patch) => onChange({ ...value, ...patch });
  const onDay = value.type === "day";

  return (
    <div className="crm-section">
      <div className="crm-section-title">Repeat On:</div>

      <label className="crm-row">
        <input type="radio" name="crm-monthly-type" checked={onDay} onChange={() => set({ type: "day" })} />
        <span className="crm-row-label">Day</span>
        <input
          type="number"
          min="1"
          max="31"
          className="crm-num"
          value={value.day}
          onFocus={() => set({ type: "day" })}
          onChange={(e) => set({ type: "day", day: e.target.value })}
        />
        <span className="crm-row-label">of every</span>
        <input
          type="number"
          min="1"
          className="crm-num"
          value={value.interval}
          onFocus={() => set({ type: "day" })}
          onChange={(e) => set({ type: "day", interval: e.target.value })}
        />
        <span className="crm-row-label">Month(s)</span>
      </label>

      <label className="crm-row">
        <input type="radio" name="crm-monthly-type" checked={!onDay} onChange={() => set({ type: "the" })} />
        <span className="crm-row-label">The</span>
        <select
          className="crm-select"
          value={value.ordinal}
          onFocus={() => set({ type: "the" })}
          onChange={(e) => set({ type: "the", ordinal: e.target.value })}
        >
          {ORDINALS.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
        <select
          className="crm-select"
          value={value.weekday}
          onFocus={() => set({ type: "the" })}
          onChange={(e) => set({ type: "the", weekday: e.target.value })}
        >
          {WEEKDAYS.map((d) => (
            <option key={d.value} value={d.value}>
              {d.label}
            </option>
          ))}
        </select>
        <span className="crm-row-label">of every</span>
        <input
          type="number"
          min="1"
          className="crm-num"
          value={value.theInterval}
          onFocus={() => set({ type: "the" })}
          onChange={(e) => set({ type: "the", theInterval: e.target.value })}
        />
        <span className="crm-row-label">Month(s)</span>
      </label>
    </div>
  );
}
